import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import { dehydrateFormData, hydrateLaunchWidgetFormData } from '../../../utils/formDataParser';
import useService from '../../../utils/useService';
import { INoticeBoard } from '../../../interfaces';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateNotice } = useService();

	const updateNotice = (updatedData: { noticeData: INoticeBoard }) => {
		setShowLoader(true);
		const { noticeData } = updatedData;

		requestUpdateNotice(app.appName, noticeData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the notice', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Notice updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateNotice(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateLaunchWidgetFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
